export default "<div class=\"div-loading-shade\">\r\n  <mat-spinner></mat-spinner>\r\n</div>";